import { useState } from "react";
import WithEmail from "./WithEmail";
import WithGAuth from "./WithGAuth";

export type signUpWith = "email" | "GAuth";

function SignUp()
{
	const [ signUpWith, setSignUpWith ] = useState<signUpWith>("GAuth");
	const [ isEdu, setIsEdu ] = useState<boolean>(false);

	return signUpWith === "GAuth" ? <WithGAuth setSignUpWith={setSignUpWith} setIsEdu={setIsEdu} /> : <WithEmail isEdu={isEdu} />;
}

export default SignUp;
